<div *ngIf="isLoading" class="centered">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>



<div *ngIf="qcFile">
    <div>
        Name: {{ qcFile.name }}
    </div>
    <div>
        File Name: {{qcFile.fileName}}
    </div>

    <div>
        Store ID: {{qcFile.storeId}}
    </div>

    <div *ngIf="store">
        Store Name: {{store.displayName}}
    </div>

    <div>
        Date ID: {{qcFile.dateId}}
    </div>

    <div>
        <button mat-raised-button color="warn" (click)="deleteQcFile()">DELETE</button>
    </div>

    <table class="table" *ngIf="!isLoading">
        <thead>
          <tr class="table-header">
            <th> Date ID </th>
            <th> Accuracy Type </th>
            <th *ngIf="qcFile.qcType == qcType.ICA_CUSTOMER_JOURNEY"> Section </th>
            <th> Hour Slot </th>
            <th *ngIf="qcFile.qcType == qcType.ICA_ENTRANCE_COUNTING"> Camera </th>
            <th> Accuracy Number </th>
            <th> System Result </th>
            <th> Qc Result Min </th>
            <th> Qc Result Max </th>
            <th> Detail </th>
            <th> Create Time </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of accuracyResults" class="table-row" [ngClass]="{
            'low-accuracy': lowAccuracyResults.has(item)
          }">
            <td> {{ item.dateId }} </td>
            <td> {{ accuracyTypeEnum[item.accuracyType] }} </td>
            <td *ngIf="qcFile.qcType == qcType.ICA_CUSTOMER_JOURNEY"> {{ item.sectionName }} </td>
            <td> {{ !HOURLY_ACCURACY_TYPES.includes(item.accuracyType) && item.hourSlot == 0 ? '' : item.hourSlot }} </td>
            <td *ngIf="qcFile.qcType == qcType.ICA_ENTRANCE_COUNTING"> {{ item.cameraId }} </td>
            <td> {{ item.accuracyNumber | percent:"1.0-2" }} </td>
            <td> {{ item.systemResult | number:"1.0-4" }} </td>
            <td> {{ item.qcResultMin | number:"1.0-4" }} </td>
            <td> {{ item.qcResultMax | number:"1.0-4" }} </td>
            <td (click)="openAccuracyResultDetailDialog(item)"> {{ item.additionalData }} </td>
            <td> {{ item.createTimeMs | date:'medium' }} </td>
          </tr>
        </tbody>
      </table>

    <div *ngIf="visitMatchRows.length > 0">
      <h3> Matched Visits ({{ visitMatchRows.length }}) </h3>
      <div class="visit-legend">
        Each cell shows the system value, then the QC value. Δ is the system duration minus the nearer edge of the
        QC range, 0 when it falls inside.
      </div>
      <table class="table">
        <thead>
          <tr class="table-header">
            <th> State </th>
            <th> System Person </th>
            <th> QC Visitor (Group) </th>
            <th *ngFor="let header of VISIT_TIME_HEADERS"> {{ header }} </th>
            <th *ngFor="let header of VISIT_DURATION_HEADERS"> {{ header }} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of visitMatchRows" class="table-row" [ngClass]="row.stateClass">
            <td> {{ row.state }} </td>
            <td> {{ row.systemPersonId }} </td>
            <td> {{ row.qcVisitorId }} <span *ngIf="row.qcGroupId">({{ row.qcGroupId }})</span> </td>
            <td *ngFor="let time of row.times">
              <div> S: {{ time.system }} </div>
              <div> QC: {{ time.qc }} </div>
            </td>
            <td *ngFor="let duration of row.durations">
              <div> S: {{ duration.system }} </div>
              <div> QC: {{ duration.qc }} </div>
              <div *ngIf="duration.error" class="visit-error"> Δ {{ duration.error }} </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

</div>